module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_0.49d10bff.png";